import en from "./langsData/en";
import fa from "./langsData/fa";

export const showMsg = (msg, lang = 'en')=>{
    // console.log(Object.getOwnPropertyNames("fa"));
    if(lang == 'en') return en.msg[msg]; else return fa.msg[msg];
}

export const isRtl = (lang = 'en')  =>{
    if(lang == 'en') return en.rtl; else return true;
}